import { canonicalTopicsGroupedQuery } from "../lib/canonicalTopicsGroupedQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useCanonicalTopicsGroupedQuery(
  ...args: Parameters<typeof canonicalTopicsGroupedQuery>
) {
  return useDashboardQuery(canonicalTopicsGroupedQuery(...args))
}
